import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_non_elligible_for_allocation_inventory_by_materialIds_packagingIds_warehouseIds_batchedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialIds: number[], packagingIds: number[], warehouseIds: number[] }): 
  Promise<{ result: { TotalNonAllocatablePackagedAmount?: number, MaterialId?: number, PackagedId?: number, Location?: { WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagingIds)) {
      $missingRequiredInParams.push('\'packagingIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { materialIds: number[], packagingIds: number[], warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalNonAllocatablePackagedAmount?: number, MaterialId?: number, PackagedId?: number, Location?: { WarehouseId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagingIds)) {
      $missingRequiredInParams.push('\'packagingIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { materialIds: number[], packagingIds: number[], warehouseIds: number[], $keys: { MaterialId?: number, Location?: { WarehouseId?: number }, PackagedId?: number }[] }): 
  Promise<{ result: { TotalNonAllocatablePackagedAmount?: number, MaterialId?: number, PackagedId?: number, Location?: { WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagingIds)) {
      $missingRequiredInParams.push('\'packagingIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialIds: number[], packagingIds: number[], warehouseIds: number[]    }) {
        if(isNil($inParams.materialIds)) {
          return true; 
        }
        if(isNil($inParams.packagingIds)) {
          return true; 
        }
        if(isNil($inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
